const ID_TOKEN_KEY = 'pp_id_token';
const ACCESS_TOKEN_KEY = 'pp_access_token';

export { ACCESS_TOKEN_KEY, ID_TOKEN_KEY };
